import Joi from 'joi';
import { _ } from '_locales';

// const phoneRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]
//* (\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
const phoneRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})\s*$/;

const email = () => Joi.string()
  .email({ tlds: { allow: false } })
  .required()
  .messages({
    'string.empty': _('general.please_provide_your_email_address'),
    'string.email': _('general.invalid_email_address')
  });

const phone = (type) => Joi.string()
  .pattern(phoneRegex)
  .min(10)
  .required()
  .messages({
    'string.empty': _('general.please_provide_your_number', { type }),
    'string.pattern.base': _('general.invalid_number', { type }),
    'string.min': _('general.invalid_number', { type }),
    'string.max': _('general.invalid_number', { type }),
  });

const emailReporter = (state) => ((
  state !== 'O'
  && state === 'M'
) ? Joi.string()
  .email({ tlds: false })
  .required()
  .messages({
    'string.empty': _('general.please_provide_your_email_address'),
    'string.email': _('general.invalid_email_address')
  })
  : Joi.string()
    .email({ tlds: false })
    .allow('').optional()
    .messages({
      'string.empty': _('general.please_provide_your_email_address'),
      'string.email': _('general.invalid_email_address')
    }));

const phoneReporter = (type, state) => ((
  state !== 'O'
  && state === 'M'
) ? Joi.string()
  .regex(phoneRegex)
  .min(10)
  .required()
  .messages({
    'string.empty': _('general.please_provide_your_number', { type }),
    'string.pattern.base': _('general.invalid_number', { type }),
    'string.min': _('general.invalid_number', { type }),
    'string.max': _('general.invalid_number', { type }),
  })
  : Joi.string()
    .regex(phoneRegex)
    .min(10)
    .allow('')
    .optional()
    .messages({
      'string.empty': _('general.please_provide_your_number', { type }),
      'string.pattern.base': _('general.invalid_number', { type }),
      'string.min': _('general.invalid_number', { type }),
      'string.max': _('general.invalid_number', { type }),
    }));

export {
  email,
  phone,
  emailReporter,
  phoneReporter,
};
